<template>
  <b-modal size="xl" title="Sugestões de CPF" :id="idPalestra">
    <p>
      Alguns CPFs não foram encontrados. Isso pode ter ocorrido pelos seguintes
      motivos:
    </p>
    <ul>
      <li>
        Pessoas que estavam no presencial preencheram o formulário, mas não se
        cadastraram no sistema
      </li>
      <li>
        Escreveram o CPF de forma incorreta no formulário
      </li>
    </ul>

    <h4 style="margin-bottom:-14px">CPF: {{ cpfs[cpfIndex].cpf }}</h4>
    <br />
    Selecione um dos CPFs da lista a seguir:
    <b-list-group>
      <b-list-group-item
        v-for="suggestion in cpfs[cpfIndex].suggestions"
        :key="suggestion.cpf"
        style="margin:0 0 0 0"
        @click="cadastrarCPF(suggestion.cpf)"
        button
        >{{ suggestion.cpf }}</b-list-group-item
      >
    </b-list-group>
    <template #modal-footer>
      <b-button @click="next" variant="primary">{{ buttonText }}</b-button>
    </template>
  </b-modal>
</template>

<script>
import { importarCPF } from "../../../services/api/Presenca";
export default {
  props: {
    idPalestra: {
      type: String,
      required: true,
    },
    cpfs: {
      type: Array,
      required: true,
    },
  },
  methods: {
    async cadastrarCPF(cpf) {
      try {
        await importarCPF(this.idPalestra, cpf);
        this.$bvToast.toast(`${cpf} recebeu presença`, {
          title: "Sucesso",
          variant: "success",
          autoHideDelay: 5000,
        });
        if (this.cpfIndex === this.cpfs.length - 1) {
          this.$bvModal.hide(this.idPalestra);
        } else {
          this.cpfIndex++;
        }
      } catch ({ response }) {
        this.$bvToast.toast(response.message, {
          title: "Erro",
          variant: "danger",
          autoHideDelay: 5000,
        });
      }
    },
    next() {
      if (this.cpfIndex === this.cpfs.length - 1) {
        this.$bvModal.hide(this.idPalestra);

        this.cpfIndex = 0;
      } else {
        this.cpfIndex++;
      }
    },
  },
  computed: {
    buttonText() {
      return this.cpfIndex < this.cpfs.length - 1 ? "Pular" : "Finalizar";
    },
  },
  data() {
    return {
      cpfIndex: 0,
    };
  },
};
</script>
